<template>
	<div class="custer-index">
		<div class="custer-index__tools">
			<h3>客户字段</h3>
			<p>
				<el-button size="mini" type="primary" icon="el-icon-plus" @click="onAdd">添加新字段</el-button>
				<el-button size="mini" type="primary" icon="el-icon-view" @click="onPreview">效果预览</el-button>
			</p>
		</div>
		<div class="custer-index__table">
			<table-pagination ref="dragTables" 
				:data="data"
				 width="100%"
				 height="70vh" 
				 :column="column"
				 row-key="columnId"
				 :row-class-name="tableRowClassName"
				 v-loading="loading">
					<template v-slot:action="{row,$index}">
						<div class="operate-inline">
							<el-button type="text" size="small" :disabled="row.columnProperty == 'alwaysOpen'" @click="onEdit(row)">编辑</el-button>
							<el-divider direction="vertical"></el-divider>
							<el-button type="text" size="small" :disabled="row.columnProperty == 'alwaysOpen'" @click="onUp($index)">上移</el-button>
							<el-divider direction="vertical" ></el-divider>
							<el-button type="text" size="small" :disabled="row.columnProperty == 'alwaysOpen'" @click="onDown($index)">下移</el-button>
						</div>
					</template>
					<template v-slot:columnNotNull="{row}">
						  <el-switch @change="onEdit(row,'columnNotNull')" v-model="row.columnNotNull" active-value="Y" inactive-value="N" :disabled="row.columnProperty == 'alwaysOpen'"></el-switch>
					</template>
					<template v-slot:state="{row}">
						  <el-switch @change="onEdit(row,'state')" v-model="row.state" active-value="Y" inactive-value="N" :disabled="row.columnProperty == 'alwaysOpen'"></el-switch>
					</template>
			</table-pagination>
		</div>
		<Details @updateList="getLists" ref="details"></Details>
		<detailItem :innerTitle="innerTitle" :displayMode="displayMode" ref="detailItem" :columnId="columnId" @updateList="getLists"></detailItem>
		<el-drawer title="效果预览" :visible.sync="previewVisable" :modal-append-to-body="false" size="60%" class="customer-drawer-common add-edit-effect" >
			<TouchIn ref="touchIn" sourceType="CustomerSettings" />
		</el-drawer>
		
	</div>
</template>
<script>
	import { getTableColumn, geImportJustDragOrder, geTadjustUpdate,getAdjustRowApi } from '@/api/manange';
	import { mapGetters } from 'vuex';
	import { custerTypes } from '../data.js';
	import Details from './components/detail.vue';
	import TouchIn from "@/views/customer/touchIn";
	import detailItem from './components/detailItem.vue';
	
	export default {
		computed: {
		    ...mapGetters([
		        'userInfo',
		    ]),
			tableData() {
				return this.data;
			}
		},
		components:{
			Details,
			TouchIn,
			detailItem
		},
		data(){
			return {
				columnId:'', //编辑所需字段
				innerTitle:'',//编辑所需字段
				displayMode:'',//编辑所需字段
				previewVisable:false,
				loading:false,
				data:[],
				column:[
					{ label: "优先级", prop: "index",type: "index",width:100 },
					{ label: "字段名称", prop: "columnName" },
					{ 
						label: "字段类型",
						prop: "displayMode",
						render:(h,scope) => {
							return <span>{custerTypes[scope.row.displayMode]? custerTypes[scope.row.displayMode][0] : '--'}</span>
						}
					},
					{ 
						label: "字段描述", 
						prop: "columnDescribe",
						render:(h,scope) => {
							return <span>{ scope.row.columnDescribe || '--'}</span>
						}
					},
					{ 
						label: "是否必填",
						renderHeader:(h,scope) => {
							return <div><span>是否必填</span>
									<el-tooltip content = "如勾选，必须填写该字段才能保存客户信息" placement = "top" >
										<i class= "el-icon-warning"></i>
									</el-tooltip></div>
						},
						prop: "columnNotNull",
						slotScope:true
					},
					{ 
						label: "是否加密", 
						prop: "encrypt" ,
						renderHeader:(h,scope) => {
							return <div><span>是否加密</span>
									<el-tooltip content = "系统后台数剧库对敏感字段进行加密保存，数剧更安全" placement = "top" >
										<i class= "el-icon-warning"></i>
									</el-tooltip></div>
						},
						render:(h,scope) => {
							return <span>{ scope.row.columnDescribe == 'Y' ? '是' : '否'}</span>
						}
					},
					{ 
						label: "是否启用", 
						prop: "state" ,
						slotScope:true
					},
					{ label: "操作", prop: "action",slotScope:true,width: 140, fixed:'right',align: "center", },
				],
				listQuery:{
					pageNumber:1,
					pageSize:10000,
					columnName:'',
					brand:''
				}
			}
		},
		methods: {
			// 列表数据
			getLists(type) {
				this.listQuery.brand = this.userInfo.brandIdentify;
				this.loading = type ? false : true;
				getTableColumn(this.listQuery).then(res => {
					this.loading = false;
					let disabledArr = [];
					if(res.errcode == 0){
						this.data = res.data;
						this.$nextTick(() => {
							this.initDrag()
						})
					}
				})
			},
			// 行拖拽
			initDrag(){
				let that= this;
				const tbody = this.$refs.dragTables.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0] // table
				let sortAble = Sortable.create(tbody,{
					sort: true,
					animation: 150,
					filter: ".disabled",
					dataIdAttr: 'data-index',
					onMove:(event,originalEvent) => {
						if(event.related.className.indexOf('disabled') !== -1) return false;
					},
					onEnd:(evt) => {
						const currRow = this.data.splice(evt.oldIndex, 1)[0]
						this.data.splice(evt.newIndex, 0, currRow);
						this.setData();
						
					}
				})
			},
			// 上移
			onUp(index){
				if (index > 0) {
					let upData = this.data[index - 1];
					if(upData.columnProperty == 'alwaysOpen') {
						this.$message.warning('处于最优先级，不能继续上移');
						return
					}
					this.data.splice(index - 1, 1)
					this.data.splice(index, 0, upData);
					this.setData();
				} else {
					this.$message.warning('处于最优先级，不能继续上移');
				}
			},
			// 下移
			onDown(index){
				if ((index + 1) == this.data.length) {
					this.$message.warning('已是最后一条，不可下移')
				} else {
					let downData = this.tableData[index + 1]
					this.data.splice(index + 1, 1)
					this.data.splice(index, 0, downData);
					this.setData();
				}
			},
			// 更新数据
			setData(){
				const newData = [];
				this.data.map((item,index) => {
					newData.push([item.columnId,index + 1])
				})
				geImportJustDragOrder({ sorts: newData}).then(res => {
					if(res.errcode != 0) {
						this.getLists('sort')
					}
				})
			},
			// 设置表格row的class
			tableRowClassName({ row }) {
			    if (row.columnProperty == "alwaysOpen") {
			        return "disabled";
			    }
			    return "";
			},
			// 设置是否必填
			onEdit(row,key){
				let params = {
					columnId: row.columnId,
					columnName: row.columnName,
					displayMode: row.displayMode,
					listQuery: row.listQuery,
					state: row.state,
					columnDescribe: row.columnDescribe,
					columnNotNull: row.columnNotNull,
				}
				if(key) {
					geTadjustUpdate(params).then(res => {
						if(res.errcode != 0){
							if(key){
								row[key] = row[key] == 'N' ? 'Y' : 'N'
							}
						}else {
						  if(!key) {
							  this.getLists()
						  }
						}
					})
				}else {
					this.columnId = row.columnId;
					this.displayMode = row.displayMode;
					this.innerTitle = custerTypes[row.displayMode]? custerTypes[row.displayMode][0] : '编辑';
					getAdjustRowApi(row.columnId).then(res => {
						if(res.errcode == 0) {
							this.$refs.detailItem.openDrawer(res.data)
						}else{
							this.$message.error(res.errmsg)
						}
					})
					// console.log(row.columnId,'row.columnId')
				}
				
			},
			//添加新字段
			onAdd(){
				this.$refs.details.onOpen()
			},
			//效果预览
			onPreview(){
				this.previewVisable = true;
				this.$nextTick(() => {
					this.$refs.touchIn.getDetailInfo()
				})
			}
		},
		created(){
			this.getLists()
		}
	}
</script>
<style lang="scss" scoped>
	.custer-index {
		&__tools {
			display: flex;
			align-items: center;
			justify-content: space-between;
			h3 {
				margin: 0;
				font-size: 14px;
			}
		}
		&__table {
			margin-top: 30px;
			::v-deep .el-table tbody {
				 cursor: move;
			}
			::v-deep .el-table .disabled {
			    background: #eee;
				cursor: not-allowed;
			}
		}
	}
</style>